import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Category } from '../../types/event-response.type';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesComponent {
  @Input()
  public itemsPerSlide = 4;

  @Input()
  public categories: Category[] = [];

  @Input()
  public isMobile: boolean = false;
}
